<template>
    <div class="m-5">
        <h4><b>Import products</b></h4>
        <b-form-group label="Select file" label-for="products-file-import">
            <b-form-file id="products-file-import"
                         v-model="files"
                         multiple
                         placeholder="Choose a file..."
                         drop-placeholder="Drop file here..."/>
            <div v-if="files.length > 0" class="mt-3">Selected files:
                <span v-for="(file, index) in files"
                      :key="index + file.name">{{file.name}}, </span>
            </div>
        </b-form-group>
    </div>
</template>

<script>
    export default {
        name: 'ImportProducts',
        data() {
            return {
                files: []
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/AddProducts/ImportProducts.vue